export const getConditionalRowStyles = (expandedRow) => [
    {
        when: row => row?.id === expandedRow?.id,
        style: {
            backgroundColor: '#d2effa',
        },
    },
];